import type { ReactNode } from 'react';
import { createContext } from 'react';

export type MainLayoutContextType = {
  title: (() => ReactNode) | string;
  setTitle: React.Dispatch<React.SetStateAction<(() => ReactNode) | string>>;
};

const MainLayoutContext = createContext<MainLayoutContextType>({
  title: '',
  setTitle: () => {},
});

export default MainLayoutContext;
